// extracted by mini-css-extract-plugin
var _1 = "_authUserProfileCard-module__block";
var _2 = "_authUserProfileCard-module__container";
var _3 = "_authUserProfileCard-module__flex";
var _4 = "_authUserProfileCard-module__hidden";
var _5 = "_authUserProfileCard-module__logout-button";
var _6 = "_authUserProfileCard-module__logout-button-text";
var _7 = "_authUserProfileCard-module__subcontainer";
var _8 = "_authUserProfileCard-module__text";
export { _1 as "block", _2 as "container", _3 as "flex", _4 as "hidden", _5 as "logout-button", _6 as "logout-button-text", _7 as "subcontainer", _8 as "text" }
